export const DEFAULT_HOME = '/';

// Long, human-readable labels for the Organización settings page.
export const CAPABILITY_FULL_LABELS = {
  backoffice: 'Plataforma',
  enterprise_law_firm: 'Estudio jurídico',
  receptor: 'Receptor judicial',
  solo_law_firm: 'Profesional independiente',
};

// The /sistema "organización" area renames itself to the kind of entity the
// active org actually is: `nav` is the sidebar item + breadcrumb label, `title`
// is the settings page heading.
const ORG_AREA = {
  backoffice: { nav: 'Plataforma', title: 'Recepthor' },
  enterprise_law_firm: { nav: 'Estudio', title: 'Estudio Jurídico' },
  receptor: { nav: 'Receptor Judicial', title: 'Receptor Jurídico' },
  solo_law_firm: { nav: 'Estudio', title: 'Estudio Jurídico' },
};

export function orgArea(capability) {
  return ORG_AREA[capability] ?? { nav: 'Organización', title: 'Organización' };
}

// Capabilities that unlock an authenticated shell. Firms and backoffice share
// MainLayout; receptores use ReceptorLayout (/solicitudes).
export const LAYOUT_CAPABLE = new Set([
  'enterprise_law_firm',
  'solo_law_firm',
  'backoffice',
  'receptor',
]);

// Landing por capability. Cada área vive bajo rutas gateadas por capability; el
// redirect de ProtectedRoute (cuando un perfil cae en una ruta que no le
// corresponde) usa esto en vez de un home único, evitando bucles. Devuelve null
// para capabilities sin área propia (null / desconocida / external_service): en
// ese caso ProtectedRoute NO redirige (eso causaría loop contra el grupo del
// estudio), sino que muestra un aviso terminal de "sin acceso".
export function homeForCapability(capability) {
  if (capability === 'backoffice') return '/plataforma/whatsapp';
  if (capability === 'receptor') return '/solicitudes';
  if (capability === 'enterprise_law_firm' || capability === 'solo_law_firm') {
    return DEFAULT_HOME;
  }
  return null;
}

// Capabilities that manage members. Personal orgs (solo_law_firm) and
// receptores have no member management, so they never see the Miembros tab.
export const MEMBERS_CAPABLE = new Set(['enterprise_law_firm', 'backoffice']);

// Deterministic color palette for org avatars.
const ORG_COLORS = [
  'hsl(210 60% 50%)',
  'hsl(340 55% 50%)',
  'hsl(160 50% 42%)',
  'hsl(30 65% 50%)',
  'hsl(270 45% 55%)',
  'hsl(190 55% 45%)',
  'hsl(0 55% 50%)',
  'hsl(130 40% 45%)',
];

export function getOrgColor(id) {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0;
  }
  return ORG_COLORS[Math.abs(hash) % ORG_COLORS.length];
}
